"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var MAX_PLAYERS = 20;
var LeaderBoard = function (_a) {
    var topPlayers = _a.topPlayers;
    var t = (0, next_intl_1.useTranslations)('translation');
    var playersCount = topPlayers.length;
    var emptyPlayers = (0, react_1.useMemo)(function () {
        return (0, apps_shared_1.generateEmptyTournamentArray)(playersCount, MAX_PLAYERS, {
            maxWidthName: 90,
            maxWidthResults: 60,
        });
    }, [playersCount]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(playersCount >= MAX_PLAYERS ? styles_module_scss_1.default.withoutBottomPadding : '') },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('leaderBoard')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.table },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.tableHead },
                react_1.default.createElement("div", null, t('position')),
                react_1.default.createElement("div", null, t('player')),
                react_1.default.createElement("div", null, t('points'))),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.tableContent, " ").concat(!(playersCount > 0) ? styles_module_scss_1.default.empty : '') }, playersCount > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_1.Suspense, { fallback: false },
                    react_1.default.createElement(ui_components_1.WithPlayers, { topPlayers: topPlayers, emptyPlayers: emptyPlayers, withFirstLeaderIcon: true })))) : (react_1.default.createElement(react_1.Suspense, { fallback: false },
                react_1.default.createElement(ui_components_1.WithoutPlayers, { emptyPlayers: emptyPlayers, showWaitPlayers: false })))))));
};
exports.default = LeaderBoard;
